import { render } from "./score.vue?vue&type=template&id=346078d0&scoped=true&ts=true&lang=pug"
import script from "./score.vue?vue&type=script&lang=ts"
export * from "./score.vue?vue&type=script&lang=ts"

import "./score.vue?vue&type=style&index=0&id=346078d0&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346078d0"]])

export default __exports__